import { render, staticRenderFns } from "./FutureHouseForm.vue?vue&type=template&id=5e0815e8"
import script from "./FutureHouseForm.vue?vue&type=script&lang=js"
export * from "./FutureHouseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0815e8')) {
      api.createRecord('5e0815e8', component.options)
    } else {
      api.reload('5e0815e8', component.options)
    }
    module.hot.accept("./FutureHouseForm.vue?vue&type=template&id=5e0815e8", function () {
      api.rerender('5e0815e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/future_house_awards/components/FutureHouseForm.vue"
export default component.exports